import type { ImageCTAStyles } from "../ImageCTA.d";

export const ImageCTAStylesDesktop: ImageCTAStyles = {
  basic: {
    container: {
      bg: "primary.900",
      color: "white",
      rounded: "xl",
    },
    image: {
      w: "50%",
    },
    textContainer: {
      w: "50%",
      pt: 10,
      pr: 0,
      pb: 6,
      pl: 6,
    },
    heading: {
      pb: 6,
      variant: "h3",
      as: "h3",
    },
    button: {},
  },

  ahPlus: {
    container: {
      minH: "188px",
      bg: "greyscale.400",
      color: "primary.900",
      rounded: "lg",
    },
    image: {
      bgPosition: "0% 0%",
      position: "absolute",
      h: "100%",
      w: "55%",
      right: 0,
      top: 0,
    },
    textContainer: { pl: 8, py: 6, pr: 3, maxW: "45%" },
    heading: {
      pb: 0,
      variant: "h5",
      as: "h5",
      lineHeight: "short",
    },
    button: {
      position: "absolute",
      bottom: 7,
      right: 8,
      variant: "primaryAlt",
      size: "sm",
    },
  },
};
